import { all, call } from 'redux-saga/effects';

import getUserNftModels from './getUserNftModels';
import selectNftModel from './selectNftModel';

export function* modelSagas() {
  yield all([getUserNftModels, selectNftModel].map(call));
}
